// Framed or not (ADR 002). Under versiyonbir.com/v1-meet the app is a normal page of the site
// (a path rewrite, no frame). The iframe embed on customer sites is the P2 path (B-019); the
// app is ready for it: in a frame, or with ?embed=1, it fills the frame with no outer chrome
// and offers "open in a new tab", which phones need for the full screen.

export interface EmbedContext {
  /** The page's query string. */
  readonly search: string;
  /** window.top !== window.self */
  readonly framed: boolean;
}

export function isEmbedded({ search, framed }: EmbedContext): boolean {
  return framed || new URLSearchParams(search).get('embed') === '1';
}

export function currentEmbedContext(win: Window = window): EmbedContext {
  let framed: boolean;
  try {
    framed = win.top !== win.self;
  } catch {
    framed = true; // some browsers refuse access to a cross-origin top: that is a frame
  }
  return { search: win.location.search, framed };
}

/** The same page without the embed switch, for "open in a new tab". */
export function standaloneUrl(href: string): string {
  const url = new URL(href);
  url.searchParams.delete('embed');
  return url.toString();
}
